import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';

const ScrollTriggeredCounter = ({ data = {} }) => {
  const [count, setCount] = useState(0);
  const targetValue = data.targetValue || 500;
  const duration = data.duration || 2000;
  const prefix = data.prefix || '';
  const suffix = data.suffix || '+';

  useEffect(() => {
    let startTime;
    let animationFrame;

    const animate = (timestamp) => {
      if (!startTime) startTime = timestamp;
      const progress = Math.min((timestamp - startTime) / duration, 1);
      
      setCount(Math.floor(progress * targetValue));

      if (progress < 1) {
        animationFrame = requestAnimationFrame(animate);
      }
    };

    animationFrame = requestAnimationFrame(animate);

    return () => {
      if (animationFrame) {
        cancelAnimationFrame(animationFrame);
      }
    };
  }, [targetValue, duration]);

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      className="flex items-center justify-center h-full bg-gradient-to-br from-purple-50 to-blue-50 p-8"
    >
      <div className="text-center">
        <div className="text-6xl font-bold text-purple-600 mb-2">
          {prefix}{count}{suffix}
        </div>
        <div className="text-gray-600 text-lg">
          {data.label || 'Happy Clients'}
        </div>
      </div>
    </motion.div>
  );
};

export default ScrollTriggeredCounter;

